import Toolbar from "components/common/Toolbar/Toolbar";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";
import mapData from "lib/stores/mapData";
import classNames from "classnames";
import DownloadButton from "./DownloadButton";
import styles from "styles/MapNavigationBar.module.scss";
import RadixSelect from "components/common/RadixSelect";
import { ReactComponent as Breadcrumb } from "components/icons/breadcrumb.svg";
// import Select from 'components/common/Select/Select';
import dictMap from "lib/helpers/dictMap";

const ToolbarMapNavigation = () => {
  const { activeCountry, activeView, activeRegion, isCollapsed } = useSnapshot(
    context,
  );
  const { countries, regions } = useSnapshot(apiData);
  const region = regions.find((region) => {
    return region.id === activeRegion;
  });

  const renderSelectedRegion = () => {
    if (!region) return null;
    return (
      <>
        <Breadcrumb />
        <button
          className={classNames(
            "md:text-base text-sm",
            styles["breadcrumb-item"],
          )}
          onClick={() => {
            context.activeView = "region";
            context.activeCountry = null;
            mapData.productsCountry = null;
            mapData.selectedProduct = null;
            context.activeTabRegions = 0;
            context.activeTabCountries = 0;
          }}
        >
          {region
            ? (
              <span
                className={!activeCountry
                  ? "!no-underline"
                  : "underline text-gray-600 hover:text-black"}
              >
                {region.name}
              </span>
            )
            : null}
        </button>
      </>
    );
  };

  const renderSelectedCountry = () => {
    if (!activeCountry) return null;
    if (window.innerWidth <= 1280) return null;
    return (
      <>
        <Breadcrumb />
        {activeCountry
          ? (
            <span
              className={classNames(
                "md:text-base text-sm whitespace-nowrap",
                styles["breadcrumb-item"],
              )}
            >
              {countries[activeCountry].name}
            </span>
          )
          : null}
      </>
    );
  };

  const setSelectedOption = (value: string) => {
    context.activeCountry = value;
    if (!activeRegion) {
      context.activeRegion = countries[value].region_id;
    }
    if (countries[value].g20) {
      mapData.productsCountry = value;
      mapData.showProducts = true;
      mapData.showProductsMobile = true;
      mapData.activeView = "country";
      mapData.selectedProduct = false;
      return;
    }
    context.activeView = "country";
    mapData.productsCountry = false;
    mapData.selectedProduct = false;
  };

  const getCountryOptions = () => {
    return dictMap(countries, (country) => {
      return {
        // label: `${country.name} (${country.iso})`,
        label: `${country.name}`,
        value: country.iso,
      };
    }).sort((a, b) => {
      if (a.name < b.name) return -1;
      return 1;
    });
  };

  return (
    <div
      id="toolbar-map-navigation-wrapper"
      className={classNames(
        styles["toolbar-map-navigation-wrapper"],
        "w-full absolute z-50 top-0 left-0 right-0 flex flex-col items-start justify-center",
      )}
    >
      <div
        id="toolbar-map-navigation"
        className={classNames(
          styles.root,
          isCollapsed ? styles["is-expanded"] : "",
        )}
      >
        <div className={styles.hotspot}>
          <div className="flex items-center justify-start space-x-2">
            <button
              className={classNames(
                "md:text-base text-sm underline",
                styles["breadcrumb-item"],
                // styles['breadcrumb-item-active'],
              )}
              onClick={() => {
                context.activeView = "worldwide";
                context.activeRegion = null;
                context.activeCountry = null;
                mapData.productsCountry = null;
                mapData.selectedProduct = null;
                context.activeTabWorldwide = 0;
                context.activeTabRegions = 0;
                context.activeTabCountries = 0;
              }}
            >
              <span
                  className={activeView !== "worldwide" ? "text-gray-600 hover:text-black duration-300" : ""}
              >
                World
              </span>
            </button>
            {renderSelectedRegion()}
            {renderSelectedCountry()}
          </div>
        </div>
        <RadixSelect
          onValueChange={setSelectedOption}
          value={activeCountry}
          triggerClassName="pointer-events-auto md:w-32 lg:w-40 h-8 md:h-10 "
          selectContentClassName="-translate-x-[2px] max-h-[800px] md:w-64 lg:w-48 xl:w-64"
          selectContentWrapperClassName="md:-translatex-0 -translate-x-[5px]"
          className=""
          groups={[
            {
              label: "Select Country",
              items: getCountryOptions(),
            },
          ]}
        />
      </div>
      {/* lg:top-[80px] md:top-[175px] sm:top-[160px] top-[160px] md:right-[20px] right-[15px] */}
      <div className="w-full flex items-center justify-end relative md:right-[20px] right-[15px] lg:top-[20px] md:top-[15px] top-[10px]">
        <DownloadButton />
      </div>
    </div>
  );
};

export default ToolbarMapNavigation;
